import { useState, useContext } from "react";
import { Avatar, Box, Stack, Typography } from "@mui/material";

import { formatDate } from "@/utils/time";
import { Verified } from "@mui/icons-material";
import NoteActions from "@/components/NoteActions";
import ActiveContentDrawer from "@/components/ActiveContentDrawer";
import { SubscribedContext } from "@/providers/Subscribed";
import { renderTextWithMentions } from "@/utils/mentions";

export default function ThreadCard({ content, index }) {
  const artistKey = content.owner.key;
  const { isSubscribed, handleModalOpen } = useContext(SubscribedContext);

  const handleClick = () => {
    if (isSubscribed) {
      setOpen(true);
    } else {
      handleModalOpen();
    }
  };

  const [open, setOpen] = useState(false);
  return (
    <Box id={content.key} key={index} sx={{ my: 2 }}>
      <Box style={{ borderRadius: "20px" }}>
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
          sx={{ pt: 2, pb: 0 }}
          onClick={handleClick}
        >
          <Avatar
            src={content.owner.meta.profile}
            sx={{ width: 20, height: 20, marginRight: 1 }}
          />
          <Typography
            variant="caption"
            style={{ marginLeft: "5px", color: "darkgray" }}
          >
            {content.owner.name}
          </Typography>
          {content.owner.role == "user" && content.owner.verified && (
            <Verified
              color="primary"
              style={{ fontSize: "16px", marginLeft: "5px" }}
            />
          )}
          {content.owner.role == "artist" && (
            <Verified
              color={content.owner.verified ? "secondary" : "disabled"}
              style={{ fontSize: "16px", marginLeft: "5px" }}
            />
          )}

          <Typography
            variant="caption"
            style={{ marginLeft: "5px", color: "darkgray" }}
          >
            • {formatDate(content.live)}
          </Typography>
        </Box>
        <Box sx={{ pt: 1 }} onClick={handleClick}>
          <Typography sx={{ fontWeight: 800, fontSize: "1.2rem" }}>
            {content.meta.title}
          </Typography>
          <Box sx={{ my: 1 }}>
            <Typography
              variant="comment"
              sx={{
                color: "lightgray",
                whiteSpace: "pre-wrap", // respect \n in text
                overflowWrap: "anywhere", // allow breaks anywhere
                wordBreak: "break-word", // break long words/urls
                // also constrain links and inline code that may be returned by renderTextWithMentions
                "& a, & code, & span": {
                  overflowWrap: "anywhere",
                  wordBreak: "break-word",
                },
              }}
            >
              {!isSubscribed && (
                <Typography
                  variant="contained"
                  color="secondary"
                  sx={{ cursor: "pointer" }}
                  onClick={() => handleModalOpen()}
                >
                  subscribe to @{content.artist_key} to view community threads
                </Typography>
              )}

              {isSubscribed && renderTextWithMentions(content.meta.text)}
            </Typography>
          </Box>
        </Box>
        <Stack
          direction="row"
          justifyContent="flex-start"
          gap={3}
          sx={{ pt: 1 }}
          alignItems={"center"}
        >
          <NoteActions content={content} />
          <Typography variant="caption" sx={{ color: "darkgray", mt: 1 }}>
            {formatDate(content.updated)}
          </Typography>
        </Stack>
      </Box>
      {/* <Divider /> */}

      <ActiveContentDrawer content={content} open={open} setOpen={setOpen} />
    </Box>
  );
}
